import ArticleImporter from "../components/ArticleImporter";

export default function ImportDraftPage() {
  return <ArticleImporter />;
}
